import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";

const HandleMealPlanOptionNameModal = ({ locals }) => {
  const { t } = useTranslation("coaching-portal");
  const { query } = locals;
  const { mealPlanName, dayType, optionId, mealPlan: mealPlanId } = query;
  // Ensure mealPlanName is always a string, even if it comes as a number from query
  const currentName = mealPlanName ? String(mealPlanName) : "";

  const [name, setName] = useState(currentName);

  const isButtonDisabled = useMemo(() => {
    return name.trim().length === 0;
  }, [name]);

  /**
   * Handle input change
   * @param {*} e
   */
  const handleInputChange = (e) => {
    const { value } = e.target;
    setName(value);
  };

  /**
   * Handle form submission
   */
  const handleSubmit = () => {
    if (!mealPlanId) {
      console.error("mealPlanId is required");
      return;
    }

    if (!dayType || !optionId) {
      console.error("dayType and optionId are required");
      return;
    }

    const body = {
      handle: "edit",
      dayType: dayType,
      optionId: optionId,
      title: String(name).trim(),
    };

    const url = `/actions/meal-planner/handle-simplified-meal-plan-option?mealPlanId=${mealPlanId}`;

    submit(url, {
      method: "POST",
      body,
    });
  };

  return (
    <Modal
      className="handle-meal-plan-template"
      title={t("editMealPlan.handleMealPlanOptionNameModal.title")}
      toClear={["mealPlanName", "dayType", "optionId", "date"]}
    >
      <div className="body">
        <div className="inputs">
          <div>
            <label className="label" htmlFor="name">
              {t("editMealPlan.handleMealPlanOptionNameModal.mealOptionName")}
            </label>
            <input
              type="text"
              placeholder={t("editMealPlan.handleMealPlanOptionNameModal.placeholder")}
              name="name"
              value={name}
              onChange={handleInputChange}
              maxLength={80}
            />
          </div>
        </div>

        <div className="buttons justify-end">
          <button
            data-button-type="primary"
            onClick={handleSubmit}
            disabled={isButtonDisabled}
            style={{ minWidth: "6rem" }}
          >
            {t("editMealPlan.handleMealPlanOptionNameModal.save")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default HandleMealPlanOptionNameModal;

HandleMealPlanOptionNameModal.propTypes = {
  locals: PropTypes.object,
};
